import React from 'react';
import { useTranslation } from 'react-i18next';
import PhoenixLogo from './PhoenixLogo';

// Full-screen loader shown during app boot / heavy route transitions.
// Renders entirely off semantic theme tokens (bg-background,
// text-foreground, text-muted-foreground, text-app-primary-500) so it
// inherits the light / dark / OLED palette automatically — no per-mode
// overrides to maintain.
const LoadingPage = () => {
  const { t } = useTranslation();

  return (
    <div
      className="fixed inset-0 z-50 bg-background flex items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <div className="text-center px-6">
        <PhoenixLogo className="w-20 h-20 mx-auto loading-pulse" />
        <h2 className="mt-6 text-2xl font-bold text-foreground" dir="auto">
          {t('loadingPage.title')}
        </h2>
        <p className="mt-2 text-base text-muted-foreground" dir="auto">
          {t('loadingPage.subtitle')}
        </p>
        <div className="flex justify-center mt-6 gap-2" aria-hidden="true">
          <span className="w-2.5 h-2.5 rounded-full bg-app-primary-500 loading-dot" style={{ animationDelay: '0ms' }} />
          <span className="w-2.5 h-2.5 rounded-full bg-app-primary-500 loading-dot" style={{ animationDelay: '150ms' }} />
          <span className="w-2.5 h-2.5 rounded-full bg-app-primary-500 loading-dot" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
